import { DocRenderer } from '@cyntler/react-doc-viewer';

import { ImageRenderer } from './ImageRenderer';
import { VideoRenderer } from './VideoRenderer';

/**
 * We defined this renderer to handle the case of a file with an octet stream type.
 * e.g. in the sync dropbox feature, we are saving the files as octet stream to the s3 bucket.
 * so we need to handle the case of a file with an octet stream type.
 */
export const OctetStreamRenderer: DocRenderer = ({ mainState }) => {
  const fileUri = mainState.currentDocument?.uri || '';
  // if its an image
  if (
    fileUri.includes('.jpg') ||
    fileUri.includes('.jpeg') ||
    fileUri.includes('.png') ||
    fileUri.includes('.gif') ||
    fileUri.includes('.webp')
  ) {
    return <ImageRenderer mainState={mainState} />;
  }
  // if its a video, render it
  if (fileUri.includes('.mp4') || fileUri.includes('.webm')) {
    return <VideoRenderer mainState={mainState} />;
  }
  return null;
};

OctetStreamRenderer.fileTypes = ['application/octet-stream'];
OctetStreamRenderer.weight = 1;
